<template>
  <div>

    <gnetModal v-bind:title="'Modulo Assegni'" v-bind:hspace="'small'"
      v-on:cancel="$emit('cancel')" v-on:submit="salva" v-bind:disabled=" tab=='camera' " >

      <div v-if="tab=='salva'">
        <div class="slds-text-heading_large">Salvataggio dati</div>
        <div>
          <icon name="check" v-if="savedTask"></icon>{{data_modulo}} - {{comunicazioni}}
        </div>
        <div v-for="assegno in assegni" v-bind:key="assegno.id" >
          <div>Assegno #{{assegno.id+1}} del {{assegno.data}}  &euro;{{assegno.importo}}  n.{{assegno.numero}}</div>
          <div v-for="photo in assegno.photos" v-bind:key="photo.id" >
            <div>Foto #{{ photo.id+1 }}</div>
            <progressbar v-bind:progress="photo.progress"></progressbar>
          </div>
        </div>
      </div>

      <div v-if="tab=='modulo'">
        <div class="slds-size_1-of-1 slds-p-top_medium slds-text-align_center" v-on:click="aggiungiAssegno">
          <button class="slds-button slds-button_icon" title="Aggiungi un assegno" :disabled="readonly">
            <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#add"></use>
            </svg>
            <span class="slds-assistive-text">Aggiungi un assegno</span>
          </button>
          Aggiungi un assegno
        </div>
        <formfield                        
          v-bind:title="'Data Registrazione'"
          v-bind:type="'date'"
          v-bind:name="'input-data-modulo'"
          v-bind:value="data_modulo"
          v-bind:placeholder="'data registrazione'"
          v-bind:disabled="readonly"
          v-on:change="data_modulo=$event" />
        <formfield                        
          v-bind:title="'Note Aggiuntive'"
          v-bind:type="'textarea'"
          v-bind:name="'textarea-comunicazioni'"
          v-bind:value="comunicazioni"
          v-bind:placeholder="'Inserisci qui le note aggiuntive'"
          v-bind:disabled="readonly"
          v-on:change="comunicazioni=$event" />

        <assegno v-for="(assegno, index) in assegni" 
          v-bind:key="assegno.id" 
          v-bind:assegno="assegno"
          v-on:delete="delAssegno(index)"
          v-on:calledCamera="callCamera(index)" 
          />

      </div>

      <div v-if="tab=='camera'">
        <foto v-bind:assegno="assegni[cameraTarget]" :readonly="readonly" v-on:cancel="tab='modulo'"></foto>
      </div>

    </gnetModal>

  </div>
</template>

<script>
//import axios from 'axios';
//import apiclient from '@/apiclient.js';
import formfield from '../components/formfield.vue'
import gnetModal from '../components/modal.vue'
import assegno from '../components/assegno.vue'
import foto from '../components/foto.vue'
import progressbar from '../components/progressbar.vue'
import icon from '../components/icon.vue'
import apiclient from '@/apiclient.js'
import moment from 'moment'

export default {
  name: 'moduloassegni',
  components: {
    formfield,
    gnetModal,
    assegno,
    foto,
    progressbar,
    icon
  },
  data: () => ({
    tab: 'modulo',
    
    assegni: [ ],
    cameraTarget: undefined,

    comunicazioni: "",
    data_modulo: undefined,
    savedTask:false,

  }),
  props: {
    readonly: { type: Boolean, default: false },
    registrationId: Number,
    recordId: String
  },
  methods: {
    saveTask: function(event) {
      console.log(event);
      var self=this;
      return new Promise(function(resolve, reject) {
        var desc=self.comunicazioni+"\n";
        self.assegni.forEach(function(a) {
          desc+=`# ${a.id+1} Assegno del ${a.data} € ${a.importo} n.${a.numero} foto: ${a.photos.length} \n`;
        })
        console.log('saving...');
        var body={ WhatId: self.recordId, Subject: "Registrazione Titoli", Description: desc, Utente__c: self.$store.state.user.email, Status: 'Completata', ActivityDate: self.data_modulo };
        apiclient.newTask(self.$store.getters.connection, body).then(function(resp) {
          console.log('saved!');
          self.savedTask=true;
          var all=[];
          self.assegni.forEach(function(a) {
            a.photos.forEach(function(p) {
              var filename=`assegno${a.id+1}-foto${p.id}.png`;
              console.log('lancia salvafoto :'+filename)
              all.push( self.savePhoto(resp.data.id, filename, p) );
            })
          })
          Promise.all(all).then(function() {
            self.tab='fine';
            resolve();
          })
        }).catch(function(err) {
          console.log(err);
          reject(err)
        })
      })
    },
    savePhoto: function(recordId, filename, pic) {
      var self=this;
      return new Promise(function(resolve, reject) {
        var data=pic.data.split(',');
        console.log(data[0]);
        var attachment= {
          ParentId: recordId,
          Name: filename,
          ContentType: 'image/png',
          Body: data[1]
        };
        pic.cb=function(ev) { pic.progress = ev.loaded / ev.total * 100; }
        console.log('saving attachment');
        apiclient.sendAttachment(self.$store.getters.connection, attachment, pic.cb).then(function() {
          console.log('saved!');
          resolve();
        }).catch(function(err) {
          console.log(err);
          reject(err)
        })
      })
    },
    callCamera: function(target) {
      this.cameraTarget = target;
      this.tab = "camera";
    },
    delAssegno: function(i) {
      this.assegni.splice(i,1);
    },
    aggiungiAssegno: function() {
      var a={ id: 0, numero:'', data:'', importo:'', photos:[] };
      if ( this.assegni.length ) a.id= this.assegni.length;
      this.assegni.push(a);
    },
    salva: function() {
      console.log(this.assegni);
      this.tab = "salva";
      var self=this;
      this.saveTask().then(function() {
        self.$emit('submit');
      })
    },
  },
  mounted() {
    console.log('assegni mounted')
    this.data_modulo = new moment().format("YYYY-MM-DD");
  },
}
</script>

<style>
</style>
